import { Breakpoint, getWidth } from '@/styles/breakpoints';
import { CSSProperties, HTMLAttributes, PropsWithChildren } from 'react';

const backgroundColorMapping = {
  normal: 'var(--color-background)',
  light: 'var(--color-background-light)',
  lighter: 'var(--color-background-lighter)',
  dark: 'var(--color-background-dark)',
  darker: 'var(--color-background-darker)',
  white: 'var(--white)',
  black: 'var(--dark)',
} as const;

export type BackgroundColorKey = keyof typeof backgroundColorMapping;

export type ContainerProps = {
  style?: CSSProperties;
  maxWidth?: Breakpoint | any;
  gutter?: CSSProperties['margin'] | boolean;
  background?: BackgroundColorKey;
} & HTMLAttributes<HTMLDivElement>;

export default function Container({
  children,
  maxWidth = 'lg',
  gutter,
  background,
  style,
  ...props
}: PropsWithChildren<ContainerProps>) {
  return (
    <div
      style={{
        backgroundColor: background ? backgroundColorMapping[background] : undefined,
      }}
    >
      <div
        style={{
          maxWidth: getWidth(maxWidth),
          marginInline: 'auto',
          marginBottom: typeof gutter === 'boolean' ? '4em' : gutter,
          marginTop: typeof gutter === 'boolean' ? 'calc(var(--navbar-height) + 4em)' : gutter,
          paddingInline: '16px',
          ...style,
        }}
        {...props}
      >
        {children}
      </div>
    </div>
  );
}
